// extracted by mini-css-extract-plugin
export default {"file":"File_file__yD3p5","header":"File_header__BDKEz","actions":"File_actions__Cr4NB"};